import { styled } from "@mui/material/styles";

const AnimalGroupColorIcon = styled("div")<{ color: string }>(({ color }) => ({
  borderRadius: "4px",
  width: "20px",
  height: "20px",
  backgroundColor: color,
  marginLeft: "2px",
}));

export default AnimalGroupColorIcon;
